<template lang="html">
  <v-row
    class="GmeliusLoader mx-auto" >
    <v-col
      cols="12"
      class="pa-0">
      <div class="GmeliusLogo animate-flicker pa-0"/>
    </v-col>
    <v-col
      cols="12"
      class="pa-0 mt-2">
      <v-row
        align-center
        no-gutters
        wrap
        justify-center>
        <v-col
          cols="12"
          class="text-center px-3 mt-5">
          <v-progress-linear
            :indeterminate="true"
            :height="4"
            color="secondary"/>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { localeMixin } from '../mixins'

export default {
  mixins: [ localeMixin ]
}
</script>

<style lang="scss" scoped>
.GmeliusLoader {
  min-width: 160px;
  max-width: 240px;
  text-align: center;

  .GmeliusLogo {
    height: 48px;
    width: 48px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
  }

  img {
    margin-left: 0.33rem
  }

  @keyframes flickerAnimation {
    0%   { opacity:1; }
    50%  { opacity:0.5; }
    100% { opacity:1; }
  }

  .animate-flicker {
    animation: flickerAnimation 1.66s infinite;
  }

}
</style>
